/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	Component
} from '@angular/core';
import {
	PageContextDirective
} from '@shared/directives/page-context.directive';
import {
	ResolverService
} from '@shared/services/resolver.service';

@Component({
	selector: 'app-session-events',
	templateUrl: './session-events.component.html'
})

/**
 * A component representing an instance of the system session events
 * component.
 *
 * @export
 * @class SessionEventsComponent
 * @extends {PageContextDirective}
 */
export class SessionEventsComponent
	extends PageContextDirective
{
	/**
	 * Creates an instance of the SessionEvents component.
	 *
	 * @param {ResolverService} resolver
	 * The resolver service used for dynamic logic and business rules.
	 * @memberof SessionEventsComponent
	 */
	public constructor(
		public resolver: ResolverService)
	{
		super(resolver);
	}
}